import { createMutation } from "@evergis/react-fetching";
import { FeatureDc } from "@evergis/api";
import { invalidateResources } from "./invalidations";
import { api as evergisApi } from "../evergis/api";
import { features } from "./features";

export type AddFeatureInput = {
  layerName: string;
  tableName: string;
  feature: FeatureDc;
};

export const addFeature = createMutation(
  ({ layerName, tableName, feature }: AddFeatureInput) =>
    async api => ({
      data: { result: await api.layers.createFeatures(layerName, [feature]), tableName, layerName },
    }),
  {
    injected: evergisApi,
    update: ({ tableName, layerName }) => {
      features.invalidateAll();

      invalidateResources([], [layerName], [tableName]);
    },
  },
);
